import styled from 'styled-components';
export const Wrapper = styled.div ``;
export const Title = styled.span `
  font: var(--heading-three-font);
  margin-bottom: 0;
`;
export default {
    Wrapper,
};
